import { Tag, Table, Button, Space, Modal } from "antd";
import dayjs from "dayjs";
import { useState } from "react";

import DeletePayoutForm from "./DeleteForm";

const ViewPayoutModal = ({
  isModalOpen = false,
  setIsModalOpen = () => {},
  payoutData = [],
  setPayoutData = () => {},
  handleDeletePayout = () => {}
}) => {
  const [isDeletePayoutModalOpen, setIsDeletePayoutModalOpen] = useState(false);
  const [currentPayoutId, setCurrentPayoutId] = useState("");
  const handleDeletePayoutWrapper = async (values) => {
    values["payoutId"] = currentPayoutId;
    handleDeletePayout(values);
  };

  const columns = [
    {
      title: "S No.",
      dataIndex: "index",
      key: "index"
    },
    {
      title: "Created By",
      dataIndex: "adminName",
      key: "adminName",
      sorter: (a, b) => {
        if (typeof a.adminName === "string" && typeof b.adminName === "string") {
          return a.adminName?.localeCompare(b.adminName) | 0;
        }
        // Fallback comparison if not string (handle the case if one or both values are not strings)
        return 0;
      }
    },
    {
      title: "Created At",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (createdAt) => dayjs(createdAt).format("DD MMM YYYY | hh:mm"),
      sorter: (a, b) => new Date(a.createdAt) - new Date(b.createdAt)
    },
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
      sorter: (a, b) => a.amount - b.amount
    },
    {
      title: "Transaction Id",
      dataIndex: "transactionId",
      key: "transactionId"
    },
    {
      title: "Deleted",
      key: "deleted",
      dataIndex: "deleted",
      render: (deleted) => {
        const color = deleted ? "red" : "green";
        return (
          <Tag color={color} key={deleted ? "Deleted" : "Persisted"}>
            {deleted ? "Deleted" : "Persisted"}
          </Tag>
        );
      }
    },
    {
      title: "Reason for Deletion",
      key: "deletionReason",
      dataIndex: "deletionReason"
    },
    {
      title: "Actions",
      key: "action",
      width: 50,

      render: (row) => (
        <div
          id="admin_row_actions"
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-around"
          }}
        >
          <Space wrap>
            <>
              <Button
                danger
                type="primary"
                disabled={row.deleted}
                onClick={() => {
                  setCurrentPayoutId(row.key);
                  setIsDeletePayoutModalOpen(true);
                }}
              >
                Delete Payout
              </Button>
            </>
          </Space>
        </div>
      )
    }
  ];

  return (
    <Modal
      title="Payouts"
      centered
      width={"100em"}
      open={isModalOpen}
      footer={[]}
      onOk={() => {
        setPayoutData([]);
        setIsModalOpen(false);
      }}
      onCancel={() => {
        setPayoutData([]);
        setIsModalOpen(false);
      }}
    >
      <Table
        columns={columns}
        dataSource={payoutData}
        bordered
        pagination={false}
        scroll={{ x: "max-content" }}
      />
      {isDeletePayoutModalOpen === true && (
        <DeletePayoutForm
          handleDeletePayout={handleDeletePayoutWrapper}
          isModalOpen={isDeletePayoutModalOpen}
          setIsModalOpen={setIsDeletePayoutModalOpen}
        />
      )}
    </Modal>
  );
};

export default ViewPayoutModal;
